import type { JourneyPhase, JourneyRow } from '../types/resume';

export const journeyRange = { start: 1983, end: 2027 };

export const journeyTicks = [1985, 1990, 1995, 2000, 2005, 2010, 2015, 2020, 2025];

export const journeyPhases: JourneyPhase[] = [
  { label: 'Engineering & projects', period: '1984 – 1989', start: 1984, end: 1990, organizations: 'ADINF, Chilectra' },
  { label: 'Solutions, product & sales', period: '1990 – 1999', start: 1990, end: 1999.75, organizations: 'Synapsis, Sybase' },
  { label: 'Regional leadership', period: '1999 – 2004', start: 1999.75, end: 2004.5, organizations: 'Sun Microsystems' },
  { label: 'Strategy', period: '2004 – 2005', start: 2004.5, end: 2005.5, organizations: 'Momentum Consulting' },
  { label: 'Market development', period: '2005 – 2016', start: 2005.5, end: 2017.5, organizations: 'Intel Corporation' },
  { label: 'CIO', period: '2017 – 2022', start: 2017.5, end: 2022.67, organizations: 'Megalabs Chile' },
  { label: 'Advisory & governance', period: '2022 – Present', start: 2022.67, end: 2026.8, organizations: 'Momentum, Provectis, COSMO CONSULT' },
];

export const journeyRows: JourneyRow[] = [
  { organization: 'ADINF', segments: [{ start: 1984, end: 1986.25, label: 'Systems Engineer', period: 'Jan 1984 – Mar 1986' }] },
  { organization: 'Chilectra', segments: [{ start: 1986.25, end: 1990, label: 'Projects Leader', period: 'Apr 1986 – Dec 1989' }] },
  {
    organization: 'Synapsis',
    segments: [
      { start: 1990, end: 1991, label: 'Customer Services Supervisor', period: 'Jan 1990 – Dec 1991' },
      { start: 1991, end: 1993, label: 'Projects Pre-Sales Leader', period: 'Jan 1991 – Dec 1992' },
      { start: 1993, end: 1995, label: 'Product Manager', period: 'Jan 1993 – Dec 1994' },
      { start: 1995, end: 1996.5, label: 'Solutions Sales Manager', period: 'Jan 1995 – Jun 1996' },
    ],
  },
  { organization: 'Sybase', segments: [{ start: 1996.5, end: 1999, label: 'Sales & Marketing Manager, Chile & Bolivia', period: 'Jul 1996 – Jan 1999' }] },
  {
    organization: 'Sun Microsystems',
    segments: [
      { start: 1999.75, end: 2001, label: 'Regional Marketing Manager, Andes Region', period: 'Oct 1999 – Dec 2000' },
      { start: 2001, end: 2003, label: 'Regional Channel & Strategic Alliances Manager', period: 'Jan 2001 – Dec 2002' },
      { start: 2003, end: 2004.5, label: 'Business Director, Perú', period: 'Jan 2003 – Jul 2004' },
    ],
  },
  {
    organization: 'Momentum Consulting',
    segments: [
      { start: 2004.5, end: 2005.5, label: 'Strategic Consultant', period: 'Jul 2004 – Jul 2005' },
      { start: 2022.67, end: 2026.8, label: 'Business & Digital Transformation Consultant', period: 'Sep 2022 – Present' },
    ],
  },
  {
    organization: 'Intel Corporation',
    segments: [
      { start: 2005.5, end: 2009, label: 'Sales Manager, Chile', period: 'Jul 2005 – Dec 2008' },
      { start: 2009, end: 2016.3, label: 'Market Development Manager, Southern Cone', period: 'Jan 2009 – Apr 2016' },
    ],
  },
  { organization: 'Megalabs Chile', segments: [{ start: 2017.5, end: 2022.67, label: 'Chief Information Officer', period: 'Jul 2017 – Aug 2022' }] },
  { organization: 'COSMO CONSULT', segments: [{ start: 2022.92, end: 2023.67, label: 'LATAM Operations Manager', period: 'Dec 2022 – Aug 2023' }] },
  { organization: 'Provectis', segments: [{ start: 2023, end: 2026, label: 'Board Member, then Chairman of the Board', period: 'Jan 2023 – Dec 2025' }] },
];

export const journeyMilestones = [
  { year: 1983, label: 'Electronic Engineer, Universidad Técnica Federico Santa María' },
  { year: 1991, label: 'Post Graduate Degree in Marketing, Universidad de Chile' },
  { year: 1993, label: 'Post Graduate Degree in Management (DPA), Universidad Adolfo Ibáñez' },
  { year: 2004, label: 'MBA, Universidad Adolfo Ibáñez' },
  { year: 2008, label: 'Coach for New Business Development, Universidad Adolfo Ibáñez' },
];
